<script>
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {faSync} from "@fortawesome/free-solid-svg-icons/faSync"
    export default {
        components: {
            FontAwesomeIcon
        },
        props: {
            userId: {
                required: false,
                type: Number
            },
        },
        data() {
            return {           
                icons: {
                    refresh: faSync
                },
                queueRefresh: false,
            }
        },
        computed: {
            bulkImportRecordsUrl() {
                return `/api/projects/bulk_import/user_logs`
            },
            spinRefresh() {
                return this.queueRefresh === true
            }
        },
        methods: {
            refreshRecords() {
                this.queueRefresh = true;
            }
        }
    }
</script>

<template>
    <div class="flex flex-col my-3 mx-4">
        <div class="flex justify-between">
            <h4 class="text-md">
                Recent Imports
            </h4>

            <div>
                <font-awesome-icon :icon="icons.refresh" :spin="spinRefresh" @click="refreshRecords"></font-awesome-icon>
            </div>
        </div>
        <div class="flex flex-col import-history-container">
            <div>
                <v-grid
                    grid-type="divRow"
                    record-type="user-project-bulk-import-result-row"
                    :record-url="bulkImportRecordsUrl"
                    :use-json-api="true"
                    :queue-refresh.sync="queueRefresh"
                    :base-record-id="userId"
                ></v-grid>
            </div>
        </div>
    </div>

</template>
